import logSummaryCallouts from './logSummaryCallouts';
import pointsChart from './pointsChart';
import prizes from './prizes';
import logComments from './logComments';

export default [logSummaryCallouts, pointsChart, prizes, logComments];
